import Vue from 'vue'

import Cookies from 'js-cookie'
//import moment from 'moment'
import axios from 'axios'
import 'normalize.css/normalize.css'

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import App from './App.vue'
import store from './store/store'
import router from './router/router'

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.config.productionTip = false

Vue.use(Antd);
Vue.use(Cookies);
//Vue.use(moment);

//require('./mock/mock.js')

Vue.prototype.axios = axios
// Vue.prototype.$form = Form

// axios.defaults.baseURL = '/api';
//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
